// (function () {

//     const preloader = document.getElementById("st-preloader");
//     const stlogowrap = document.getElementById("st-logo-wrap");

//     if (!preloader) {
//         console.log("Preloader not found");
//         return;
//     }

//     console.log("Preloader script loaded");

//     if (sessionStorage.getItem("st_preloader_seen") === "1") {
//         console.log("Already shown in this session");
//         preloader.classList.add("finished");
//         return;
//     }

//     console.log("First time - showing preloader");
//     preloader.classList.add("show");

//     document.documentElement.classList.add("loading");
//     document.body.classList.add("loading");

//     window.addEventListener("load", function () {

//         console.log("Window loaded");

//         if (stlogowrap) {
//             stlogowrap.classList.add("open");
//         }

//         setTimeout(function () {
//             console.log("Opening preloader");
//             preloader.classList.add("open");
//         }, 4000);


//         setTimeout(function () {

//             console.log("Finishing preloader");

//             preloader.classList.add("finished");

//             document.documentElement.classList.remove("loading");
//             document.body.classList.remove("loading");

//             sessionStorage.setItem("st_preloader_seen", "1");

//             console.log(
//                 "Saved:",
//                 sessionStorage.getItem("st_preloader_seen")
//             );

//         }, 5000);

//     });

// })();

(function () {

    const preloader = document.getElementById("st-preloader");
    const stlogowrap = document.getElementById("st-logo-wrap");

    if (!preloader) {
        console.log("Preloader not found");
        return;
    }

    console.log("Preloader script loaded");

    if (sessionStorage.getItem("st_preloader_seen") === "1") {
        console.log("Already shown in this session");
        preloader.classList.add("finished");
        return;
    }

    console.log("First time - showing preloader");
    preloader.classList.add("show");

    document.documentElement.classList.add("loading");
    document.body.classList.add("loading");

    console.log("Starting preloader immediately");

    if (stlogowrap) {
        stlogowrap.classList.add("open");
    }

    setTimeout(function () {
        console.log("Opening preloader");
        preloader.classList.add("open");
    }, 4000);

    setTimeout(function () {

        console.log("Finishing preloader");

        preloader.classList.add("finished");

        document.documentElement.classList.remove("loading");
        document.body.classList.remove("loading");

        sessionStorage.setItem("st_preloader_seen", "1");

        console.log(
            "Saved:",
            sessionStorage.getItem("st_preloader_seen")
        );

    }, 5000);

})();